<proffeo-ui-dialog [title]="data.titleKey | translate">
  <div class="flex flex-col w-full h-full gap-2">
    @if (data.users.length) {
      <proffeo-select-users-list
        [(selectedUsers)]="selectedUserIds"
        [lockedUserIds]="data.lockedUserIds ?? []"
        [originalUsers]="data.users"
      />
    } @else if (data.emptyMessageKey) {
      <p class="text-sm text-proffeo-muted">{{ data.emptyMessageKey | translate }}</p>
    }
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      variant="secondary"
      text="common.cancel"
      matDialogClose
    />
    <proffeo-ui-button
      (clicked)="save()"
      variant="accent"
      text="common.save"
    />
  </div>
</proffeo-ui-dialog>
